var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccpetedInvite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M25,45A20,20,0,0,1,10.858,10.857,20,20,0,0,1,39.143,39.142,19.873,19.873,0,0,1,25,45ZM25,7.051a17.947,17.947,0,1,0,12.691,5.257A17.836,17.836,0,0,0,25,7.051Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(17.204 19.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M43.639,48.612a1.026,1.026,0,0,1-.725-1.751l9.026-9.027a1.026,1.026,0,0,1,1.45,1.45l-9.026,9.027A1.024,1.024,0,0,1,43.639,48.612Z",
    transform: "translate(-38.099 -37.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M37.995,54.254a1.022,1.022,0,0,1-.725-.3l-4.513-4.512a1.026,1.026,0,1,1,1.45-1.45L38.72,52.5a1.025,1.025,0,0,1-.725,1.75Z",
    transform: "translate(-32.456 -43.177)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccpetedInvite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/accpeted_invite.42a6fe9f91253db4fede4d57a33b4b13.svg";